/**
 * Enroll Support Group manifest — `enroll-support-group` action (design doc §2.4).
 *
 * The action's primary (and only) entity is the company itself, so there is no
 * relationship walk: `clientRun` opens the enroll-support-group modal preset to
 * the source company. On the company detail page this manifest's client-redirect
 * falls through to the `enrollSupportGroup` handler (same modal); other surfaces
 * (Slack resolver) drive it through `clientRun` here.
 */

import { MODAL_IDS } from "@wtc/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "enroll-support-group",
  label: "Enroll support group",
  primaryEntity: "company",
  requires: {
    entity: "company",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.companies.enrollSupportGroup, {
      companyId: resolved.sourceId,
    });
  },
});
